/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ApiFrontendInternalLinkingCityRetrieve200ResultsMetadataLocationType =
  (typeof ApiFrontendInternalLinkingCityRetrieve200ResultsMetadataLocationType)[keyof typeof ApiFrontendInternalLinkingCityRetrieve200ResultsMetadataLocationType];

export const ApiFrontendInternalLinkingCityRetrieve200ResultsMetadataLocationType = {
  REGION: 'REGION',
  CITY: 'CITY',
  NEIGHBORHOOD: 'NEIGHBORHOOD',
} as const;
